import classNames from "classnames";
import { __ } from "@common/helpers/i18n";

export function LoadProgress({ className }: { className?: string }) {
  return (
    <div
      data-load-progress
      role="progressbar"
      aria-hidden="true"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={0}
      className={classNames(
        "pointer-events-none fixed inset-x-0 top-0 z-progress hidden h-0.5 overflow-hidden bg-primary/10",
        className,
      )}
    >
      <span
        data-load-progress-bar
        className="absolute inset-y-0 start-0 block w-0 bg-gradient-to-l from-primary via-info to-primary/70 shadow-[0_0_10px_hsl(var(--primary)/0.32)] transition-[width] duration-500 ease-out"
      />
      <span className="sr-only">{__("Loading")}</span>
    </div>
  );
}
